<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <card :title="stats.money.title" :value="stats.money.value" :percentage="stats.money.percentage" :iconClass="stats.money.iconClass" :iconBackground="stats.money.iconBackground" :detail="stats.money.detail" directionReverse></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card :title="stats.users.title" :value="stats.users.value" :percentage="stats.users.percentage" :iconClass="stats.users.iconClass" :iconBackground="stats.users.iconBackground" :detail="stats.users.detail" directionReverse></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.clients.title"
              :value="stats.clients.value"
              :percentage="stats.clients.percentage"
              :iconClass="stats.clients.iconClass"
              :iconBackground="stats.clients.iconBackground"
              :percentageColor="stats.clients.percentageColor"
              :detail="stats.clients.detail"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card :title="stats.sales.title" :value="stats.sales.value" :percentage="stats.sales.percentage" :iconClass="stats.sales.iconClass" :iconBackground="stats.sales.iconBackground" :detail="stats.sales.detail" directionReverse></card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from "@/examples/Cards/Card.vue";

  import US from "@/assets/img/icons/flags/US.png";
  import DE from "@/assets/img/icons/flags/DE.png";
  import GB from "@/assets/img/icons/flags/GB.png";
  import BR from "@/assets/img/icons/flags/BR.png";

  import axios from "axios";
  import sha256 from "crypto-js/sha256";

  export default {
    name: "dashboard",
    data() {
      return {
        stats: {
          money: {
            title: "Today's Money",
            value: "$53,000",
            percentage: "+55%",
            iconClass: "ni ni-money-coins",
            detail: "since yesterday",
            iconBackground: "bg-gradient-primary",
          },
          users: {
            title: "Today's Users",
            value: "2,300",
            percentage: "+3%",
            iconClass: "ni ni-world",
            iconBackground: "bg-gradient-danger",
            detail: "since last week",
          },
          clients: {
            title: "New Clients",
            value: "+3,462",
            percentage: "-2%",
            iconClass: "ni ni-paper-diploma",
            percentageColor: "text-danger",
            iconBackground: "bg-gradient-success",
            detail: "since last quarter",
          },
          sales: {
            title: "Sales",
            value: "$103,430",
            percentage: "+5%",
            iconClass: "ni ni-cart",
            iconBackground: "bg-gradient-warning",
            detail: "than last month",
          },
        },
        sales: {
          us: {
            country: "United States",
            sales: 2500,
            value: "$230,900",
            bounce: "29.9%",
            flag: US,
          },
          germany: {
            country: "Germany",
            sales: "3.900",
            value: "$440,000",
            bounce: "40.22%",
            flag: DE,
          },
          britain: {
            country: "Great Britain",
            sales: "1.400",
            value: "$190,700",
            bounce: "23.44%",
            flag: GB,
          },
          brasil: {
            country: "Brasil",
            sales: "562",
            value: "$143,960",
            bounce: "32.14%",
            flag: BR,
          },
        },
      };
    },
    components: {
      Card,
    },
    computed: {
      currentRouteName() {
        const routeArr = this.$route.path.split("/");
        return routeArr[1];
      },
    },
    created() {
      let data = {
        user: {
          id: this.$store.state.user.id,
        },
      };

      let JWTToken = localStorage.getItem("token");

      if (JWTToken == undefined) {
        if (!this.getLogged()) {
          this.$router.push({ name: "Signin" });
        }
      } else {
        if (this.currentRouteName != "Invitation") {
          axios
            .post("https://api.macra.co.id/mavent/admin/keep-login", data, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              this.$store.state.user.keeplogged = true;
              this.keepLogged();
            })
            .catch((error) => {
              this.$store.state.user = "";
              if (!this.getLogged()) {
                this.$router.push({ name: "Dashboard" });
              }
            });
        }
      }
    },
    methods: {
      getLogged() {
        return this.$store.state.user.keeplogged;
      },
      keepLogged() {
        if (this.getLogged() != true) {
          this.$router.push({ name: "Signin", query: { redirect: "/signin" } });
        }
      },
    },
  };
</script>
